const info = {
  ZH: { //中文翻译
    passwordupdata: '修改密码',
    newpassword: '新密码',
    repassword: '重复输入',
    updata: '修改',
    cancel: '关闭',
    messageone: '两次输入的密码不一样',
    messagetwo: '修改失败',
    messageThree: '新密码不得与旧密码相同，请重新输入。',
    messageFour: '您的密码没有过期，不需使用本功能。',
    nullcheck: '不能为空',
    firstlogin: '出于安全原因您的密码每隔90天必须更换一次。',
    firstlogin1: '您是第一次登录系统,请先对原始密码进行修改。',
    length: '您输入的密码位数少于8位，请重新输入。',
    strength: '您输入的密码需包含至少一位大写字母一位小写字母和一位数字长度为8~15',
  },
  EN: {
    passwordupdata: 'Modify password',
    newpassword: 'New password',
    repassword: 'confirm the password',
    updata: 'Modify',
    cancel: 'Close',
    messageone: 'The passwords you entered do not match',
    messagetwo: 'Failure to modify',
    messageThree: 'Please do not enter the old password, a new password is required.',
    messageFour: '您的密码没有过期，不需使用本功能。',
    nullcheck: 'should not be blank',
    firstlogin: 'Please change your original password.',
    firstlogin1: 'This is your first time to log in  CAMDS ,please change your original password.',
    length: 'Please enter a password with at least 8 characters.',
    strength: 'The password you enter should contain at least one upper case letter, one lower case letter and one number;The length is 8~15',
  }
}

export default info //需要暴露出去
